import verification from "data/verification";
import { Profile } from "services/generated";

export function getInvestmentJourneyStatus(profileData: Profile) {
  if (profileData.journeyCompleted) {
    return 'INVESTMENT_JOURNEY_COMPLETE';
  }
  if (
    profileData.verificationStatus == verification.Unverified || 
    profileData.verificationStatus?.includes(verification.Unverified)
  ) {
    return 'UNVERIFIED';
  }
  if (
    profileData.verificationStatus == verification.InProgress ||
    profileData.verificationStatus == verification.Incomplete
  ) {
    return 'VERIFICATION_IN_PROGRESS';
  }
  if (
    profileData.verificationStatus == verification.Pending
  ) {
    return 'VERIFICATION_UNDER_REVIEW';
  }
  if (profileData.depositState == 'None') {
    return 'MAKE_DEPOSIT';
  }
  if (!profileData.investmentCompleted) {
    return 'INVESTMENT_JOURNEY_COMPLETE';
  }
  return null;
}